import { useEffect } from "react";
import { TFormHookParams, IFormSection } from "../../types/common";
import useGet from "../common/useGet";
import useSearchOptions from "../common/useSearchOptions";
import { API_DISTRICTS, API_FIXED_WAGES, API_USERS } from "../../utils/apis";
import {
  addSelectItem,
  getRegister,
  userSelectItem,
} from "../../utils/helpers";
import { URL_FIXED_WAGES } from "../../utils/urls";

export const useFixedWageForm = ({ id, form }: TFormHookParams = {}) => {
  const isUpdate = !!id;

  const {
    loadData: getCities,
    data: cities,
    loading: loadingCities,
  } = useGet();

  useEffect(() => {
    getCities({ api: API_DISTRICTS });
  }, []);

  const cityName = cities?.find((c: any) => c.id === form.city)?.name;

  const users = useSearchOptions({
    api: API_USERS,
    searchParam: "first_name",
    params: { district: cityName },
    enabled: !!cityName,
    toOption: userSelectItem,
  });

  const sections: IFormSection[] = [
    {
      title: "Fixed Wage Details",
      fields: [
        {
          field_name: "city",
          type: "select",
          label: "City",
          loading: loadingCities,
          options_data: cities?.map((sup: any) =>
            addSelectItem({
              label: `${sup?.name}`,
              value: sup?.id,
            }),
          ),
          props: {
            required: isUpdate ? false : true,
            placeholder: "Select city",
          },
        },
        {
          field_name: "user",
          type: "select",
          label: "User",
          search: users,
          props: {
            required: isUpdate ? false : true,
            placeholder: "Select user",
            min: 0,
          },
        },
        {
          field_name: "fixed_wage",
          type: "number",
          label: "Fixed Wage",
          visible: form?.staff_type !== "AGENT",
          props: {
            required: isUpdate ? false : true,
            min: 0,
          },
        },
        {
          field_name: "effective_date",
          type: "date",
          label: "Effective date",
          props: {
            required: isUpdate ? false : true,
            min: 0,
          },
        },
        {
          field_name: "is_active",
          label: "Status",
          type: "select",
          visible: isUpdate,
          props: {
            required: isUpdate ? false : true,
            placeholder: "Select Status",
            options: [
              { value: true, label: "Active" },
              { value: false, label: "Inactive" },
            ],
          },
        },
      ],
    },
  ];

  const title = "Fixed Wage Configuration";
  const redirect = getRegister(URL_FIXED_WAGES);

  const onSubmit = (payload: any) => {
    if (id) {
      return {
        id,
        api: API_FIXED_WAGES,
        params: {
          ...payload,
        },
      };
    }
    return {
      api: API_FIXED_WAGES,
      params: {
        ...payload,
      },
    };
  };

  return {
    sections,
    onSubmit,
    title,
    redirect,
  };
};
